import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { BlockConnector } from './BlockConnector';
import { BlockContextProvider } from './BlockContext';
import { useContracts } from './useContracts';
import { ViewConverter } from './viewConverter';
import { jsx as _jsx } from "react/jsx-runtime";
export var PreConfiguredBlock = function PreConfiguredBlock(_ref) {
  var configuration = _ref.configuration,
    piletApi = _ref.piletApi,
    paramSources = _ref.paramSources,
    contractData = _ref.contractData;
  var contractDataWithFallback = contractData !== null && contractData !== void 0 ? contractData : paramSources;
  var contractDataSources = useContracts(contractDataWithFallback);
  var _React$useMemo = React.useMemo(function () {
      var convertedView = ViewConverter.convertView({
        view: {
          containerRID: "sharefile:account-*/preconfigured-".concat(configuration.blockName)
        },
        layout: {
          block: configuration
        }
      });
      var rootBlock = convertedView.blocks.find(function (convertedBlock) {
        return convertedBlock.parentZoneRID === 'root';
      });
      return [convertedView, rootBlock];
    }, [configuration]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    view = _React$useMemo2[0],
    block = _React$useMemo2[1];
  var allViews = React.useMemo(function () {
    return [view];
  }, [view]);
  return /*#__PURE__*/_jsx(BlockContextProvider, {
    view: view,
    piletApi: piletApi,
    blockRID: view.rootBlockRID,
    changeView: function changeView() {},
    completeInteraction: function completeInteraction() {},
    cancelInteraction: function cancelInteraction() {},
    allViews: allViews,
    contractSources: contractDataSources,
    children: /*#__PURE__*/_jsx(BlockConnector, {
      block: block
    })
  });
};